import { css } from '@genesislcap/web-core';
import { closeIconStyles } from '../../../../pbi/styles/styles';
import {
  HIGHLIGHT_RECONFIRM_BG,
  HIGHLIGHT_RECONFIRM_BLUE,
  thinHorizontalScrollbarStyles,
} from '../../../../pbi/styles';

export const dealsStyles = css`
  ${closeIconStyles}
  ${thinHorizontalScrollbarStyles}

  :host {
    padding: 10px;
    display: block;
    height: 100%;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    --accent-foreground-rest: #7aa3e0;
    --accent-fill-rest: #7aa3e0;
    --thin-h-scroll-height: 6px;
    --thin-h-scroll-padding-bottom: 0px;
  }
  rapid-tab rapid-icon {
    margin-left: 5px;
  }
  
  rapid-tabs::part(tablist) {
    height: auto;
  }

  rapid-tabs::part(tab) {
    display: flex;
  }
  
  .deal-tab-description {
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  @keyframes tab-reconfirm-blink {
    0%, 100% {
      background: ${HIGHLIGHT_RECONFIRM_BG};
    }
    50% {
      background: rgb(74, 158, 255, 0.4);
    }
  }

  /* Blue highlight for any deal in Verbal Award/CXL Window */
  rapid-tab.tab-reconfirm-window {
    border-left: 3px solid ${HIGHLIGHT_RECONFIRM_BLUE};
    background: ${HIGHLIGHT_RECONFIRM_BG};
    padding-left: 6px;
  }

  /* Blink animation only when deal has reconfirm-eligible orders */
  rapid-tab.tab-reconfirm-window-blink {
    animation: tab-reconfirm-blink 1.5s ease-in-out infinite;
  }

  rapid-tab.tab-reconfirm-window-active {
    color: #fff;
    animation: none;
    background: ${HIGHLIGHT_RECONFIRM_BG};
  }

  rapid-tab.tab-reconfirm-window-active .deal-tab-description,
  rapid-tab.tab-reconfirm-window-active rapid-icon {
    color: #fff !important;
  }

  /* Stop Deal Listing tab from highlighting when user is on it (same as deal detail tabs). */
  rapid-tab.deals-tab-active {
    animation: none;
  }

  .active-deals {
    margin-bottom: 20px;
    max-width: 350px;
    max-height: 350px;
    overflow: auto;
    border: 1px solid var(--neutral-stroke-rest);
    
    .active-deals-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      gap: 10px;
      font-size: 14px;
      
      .active-deals-item-description {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      
      .active-deals-item-close {
        cursor: pointer;
        padding: 5px;
        margin-left: 10px;
      }

      .active-deals-item-close:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      rapid-icon {
        cursor: pointer;
      }
    }
  }
  
`
